var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.75C1.55964 5.75 1 5.19036 1 4.5C1 3.80964 1.55964 3.25 2.25 3.25H21.75C22.4404 3.25 23 3.80964 23 4.5C23 5.19036 22.4404 5.75 21.75 5.75H2.25Z",
    fill: "#002D72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 13.25C1.55964 13.25 1 12.6904 1 12C1 11.3096 1.55964 10.75 2.25 10.75H21.75C22.4404 10.75 23 11.3096 23 12C23 12.6904 22.4404 13.25 21.75 13.25H2.25Z",
    fill: "#002D72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 20.75C1.55964 20.75 1 20.1904 1 19.5C1 18.8096 1.55964 18.25 2.25 18.25H21.75C22.4404 18.25 23 18.8096 23 19.5C23 20.1904 22.4404 20.75 21.75 20.75H2.25Z",
    fill: "#002D72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.21551976bee3981c2c776958c3817ce4.svg";
export { ForwardRef as ReactComponent };